import React, { useState, useContext } from 'react';
import { TextField, Checkbox, Button, Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2'; // Import Grid2 as Grid
import axios from 'axios';
import { useNavigate, useSearchParams, Link as RouterLink, useLocation } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import { Theme } from '../../components/Theme';

export default function Login() {
    const [input, setInput] = useState({
        email: '',
        password: '',
        rememberMe: false,
    });
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate(); // Hook to navigate to other pages
    const [searchParams] = useSearchParams();
    const { fetchUserInfo } = useContext(UserContext);
    const location = useLocation();

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setInput((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/account/login', {
                email: input.email,
                password: input.password,
                rememberMe: input.rememberMe,
            });
            if (response.status === 200) {
                // Fetch user info after successful login
                await fetchUserInfo();
                // Get the returnUrl from query parameters, default to '/' if not present
                const returnUrl = searchParams.get('returnUrl') || '/';
                navigate(returnUrl);
            }
        } catch (error) {
            setErrorMessage('Login failed. Please check your credentials and try again.');
            console.error('Login error:', error);
        }
    };

    return (
        <Theme>
            <Box 
                sx={{ 
                    p: 2,
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Box sx={{ maxWidth: 400, width: '100%' }}>
                    <Typography variant="h4" gutterBottom>
                        Iniciar sesión
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12 }}>
                            {errorMessage && (
                                <Typography color="error" gutterBottom>
                                    {errorMessage}
                                </Typography>
                            )}
                            <form onSubmit={handleSubmit} name="login">
                                <Typography variant="body1" gutterBottom>
                                    Utilice una cuenta local para iniciar sesión.
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            variant="standard"
                                            fullWidth
                                            label="Correo electrónico"
                                            placeholder="name@example.com"
                                            name="email"
                                            value={input.email}
                                            onChange={handleChange}
                                            autoComplete="username"
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            variant="standard"
                                            fullWidth
                                            label="Contraseña"
                                            placeholder="password"
                                            name="password"
                                            type="password"
                                            value={input.password}
                                            onChange={handleChange}
                                            autoComplete="current-password"
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Checkbox
                                            name="rememberMe"
                                            checked={input.rememberMe}
                                            onChange={handleChange}
                                        />
                                        Recordarme
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                        >
                                            Iniciar sesión
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid size={{xs: 12}}>
                                    <RouterLink 
                                        to={`/account/forgotpassword?from=${encodeURIComponent(location.pathname + location.search)}`}
                                        style={{ color: 'primary' }}
                                    >
                                        ¿Olvidaste tu contraseña?
                                    </RouterLink>
                                    <br />
                                    <a href={window.location.origin} style={{ color: 'primary' }}>
                                        A mi página principal
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Theme>
    );
}
